import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';

// routes
import AuthenticationRoutes from './AuthenticationRoutes';
import MainLayout from 'layout/MainLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';
import KYC from 'views/pages/Kyc';
import MyWallet from 'views/pages/MyWallet';
import BettingHistory from 'views/pages/BettingHistory';
import MyActivity from 'views/pages/MyActivity';
import LoginRoutes from './LoginRoutes';
import TermsCondition from 'views/pages/Termscondition';
// sample page routing
const HomePage = Loadable(lazy(() => import('views/landing-page')));
const GamePage = Loadable(lazy(() => import('./../views/pages/GamePage')));
const GamesPage = Loadable(lazy(() => import('./../views/pages/GamesPage')));
const RacingPage = Loadable(lazy(() => import('./../views/pages/betting/index')));
const GameOddEven = Loadable(lazy(() => import('./../views/pages/GameOddEven/GameOddEven')));
const LuckcySign = Loadable(lazy(() => import('./../views/pages/LuckySign/Bet')));
const ColorSign36 = Loadable(lazy(() => import('./../views/pages/ColorSign36/GamePlayColorSign36')));
const MyAccount = Loadable(lazy(() => import('./../views/pages/MyAccount')));
const Terms = Loadable(lazy(() => import('views/pages/Termscondition')));
const Betrules = Loadable(lazy(() => import('views/pages/betrules')));
const Raceresults = Loadable(lazy(() => import('views/pages/raceresults')));
const Luckyrsults = Loadable(lazy(() => import('views/pages/luckyrsults')));
const Locations = Loadable(lazy(() => import('views/pages/locations')));
const Responsiblegaming = Loadable(lazy(() => import('views/pages/responsiblegaming')));
const Privacypolicy = Loadable(lazy(() => import('views/pages/privacypolicy')));
const Aboutus = Loadable(lazy(() => import('views/pages/aboutus')));
const Maintenance = Loadable(lazy(() => import('views/pages/maintenance')));
const Accessdenied = Loadable(lazy(() => import('views/pages/accessdenied')));
const Devicelimit = Loadable(lazy(() => import('views/pages/devicelimit')));

const Faqs = Loadable(lazy(() => import('views/pages/faqs/faqs')));

const PaymentCancel = Loadable(lazy(() => import('views/pages/payment/cancel')));
const PaymentReturn = Loadable(lazy(() => import('views/pages/payment/return')));

const Contactus = Loadable(lazy(() => import('views/pages/contact/contactus')));

const FaqsDetails = Loadable(lazy(() => import('views/pages/faqs/pages/FaqsDetails')));
const FaqAccountAssistance = Loadable(lazy(() => import('views/pages/faqs/pages/FaqAccountAssistance')));
const FaqDepositsWithdrawals = Loadable(lazy(() => import('views/pages/faqs/pages/FaqDepositsWithdrawals')));
// const FaqEgamesInquiries = Loadable(lazy(() => import('views/pages/faqs/pages/FaqEgamesInquiries')));
const FaqGettingStarted = Loadable(lazy(() => import('views/pages/faqs/pages/FaqGettingStarted')));
// const FaqRtggamesInquiries = Loadable(lazy(() => import('views/pages/faqs/pages/FaqRtggamesInquiries')));
const FaqSportsbetsEnquiries = Loadable(lazy(() => import('views/pages/faqs/pages/FaqSportsbetsEnquiries')));
const FaqTrustSafety = Loadable(lazy(() => import('views/pages/faqs/pages/FaqTrustSafety')));

const Payoout = Loadable(lazy(() => import('./../views/pages/payment/payout')));
const CashinCashout = Loadable(lazy(() => import('./../views/pages/payment/cashin-cashout')));

// const KYC = Loadable(lazy(() => import('./../views/pages/Kyc')));
// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
    [
        {
            path: '/',
            element: (
                <AuthGuard>
                    <MainLayout />
                </AuthGuard>
            ),
            children: [
                { path: '/', element: <HomePage /> },
                { path: '/terms', element: <Terms /> },
                { path: 'locations', element: <Locations /> },
                { path: 'betrules', element: <Betrules /> },
                { path: 'responsiblegaming', element: <Responsiblegaming /> },
                { path: 'privacypolicy', element: <Privacypolicy /> },
                { path: 'aboutus', element: <Aboutus /> },
                { path: '/contactus', element: <Contactus /> },
                { path: 'faqs/*', element: <Faqs /> },

                { path: 'maintenance', element: <Maintenance /> },
                { path: 'devicelimit', element: <Devicelimit /> },
                { path: 'raceresults/:providerId', element: <Raceresults /> },
                { path: 'results/luckysign', element: <Luckyrsults /> },
                { path: 'details', element: <FaqsDetails /> },
                { path: 'gettingstarted', element: <FaqGettingStarted /> },
                { path: 'depositswithdrawals', element: <FaqDepositsWithdrawals /> },
                { path: 'sportsbetsenquiries', element: <FaqSportsbetsEnquiries /> },
                { path: 'accountassistance', element: <FaqAccountAssistance /> },
                { path: 'trustsafety', element: <FaqTrustSafety /> },
                {
                    path: 'payment',
                    children: [
                        { path: 'return/:id', element: <PaymentReturn /> },
                        { path: 'cancel/:id', element: <PaymentCancel /> }
                    ]
                },

                {
                    path: '/games/:providerId',
                    element: <GamesPage />
                },
                {
                    path: '/game/:providerId/:gameId',
                    element: <GamePage />
                },
                {
                    path: '/racing/:rId/:rNumber/:racingType',
                    element: <RacingPage />
                },
                {
                    path: 'luckysign/:id',
                    element: <LuckcySign />
                },
                {
                    path: 'luckysign36/:id',
                    element: <ColorSign36 />
                },
                {
                    path: '/marbleracing/:rId/:rNumber/:racingType',
                    element: <RacingPage />
                },
                {
                    path: '/marbleracingfixed/:rId/:rNumber/:racingType',
                    element: <RacingPage />
                },
                {
                    path: '/provider/:module',
                    element: <GameOddEven />
                },
                {
                    path: '/myaccount',
                    element: <MyAccount />
                },
                {
                    path: '/transactions',
                    element: <MyWallet />
                },
                {
                    path: '/bettinghistory',
                    element: <BettingHistory />
                },
                {
                    path: '/activity',
                    element: <MyActivity />
                },
                {
                    path: '/kyc',
                    element: <KYC />
                },
                {
                    path: '/termscondition',
                    element: <TermsCondition />
                },

                {
                    path: '/payout',
                    element: <Payoout />
                },
                {
                    path: '/cashin-cashout',
                    element: <CashinCashout />
                }
            ]
        },
        {
            path: 'accessdenied',
            element: <Accessdenied /> // No MainLayout here
        },
        AuthenticationRoutes,
        LoginRoutes
    ],
    {
        basename: import.meta.env.VITE_APP_BASE_NAME
    }
);
export default router;
